"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadCollapsibleListModule = () => ({
    hasRouter: false,
    modules: [],
});
exports.default = loadCollapsibleListModule;
